import { repo, SqlDatabase, type ClassType, type EntityFilter } from "remult";

export async function doesExist<Entity>(
  entity: ClassType<Entity>,
  filter: EntityFilter<Entity>,
): Promise<boolean> {
  const cmd = SqlDatabase.getDb().createCommand();

  const metadata = repo(entity).metadata;

  const rawFilter = await SqlDatabase.filterToRaw(entity, filter);

  const result = await cmd.execute(`
        SELECT EXISTS (
            SELECT 1
            FROM "${metadata.dbName}"
            ${rawFilter ? `WHERE ${rawFilter}` : ""}
        )
    `);

  return result.rows[0]?.exists === true;
}
